import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  latitude: number;
  longitude: number;
};
export type JooserValidAddressRequest = {
  data: {
    valid: boolean;
  };
};

export const useJooserValidAddressRequest = createQuery<
  JooserValidAddressRequest,
  Variables,
  AxiosError
>({
  queryKey: ['jooser/valid-address-request'],
  fetcher: ({ id, latitude, longitude }) => {
    return client
      .get(
        `v2/reservations/${id}/jooser/valid-address-request?latitude=${latitude}&longitude=${longitude}`
      )
      .then((response) => {
        return response.data.data;
      });
  },
});
